<template>
  <main id="main">
    <div class="layout-center-wrap">
      <!-- 메인 슬라이더 + 로그인 컬럼 레이아웃 -->
      <section class="banner-visual-login-panel__block">
        <h2 class="sr-only">메인 배너</h2>
        <section
          class="banner-visual"
          aria-roledescription="carousel"
          role="region"
          aria-label="메인 배너"
        >
          <Swiper
            class="intro-swiper"
            :modules="bannerModules"
            :slides-per-view="1"
            :loop="bannerItems.length > 1"
            :autoplay="{ delay: 5000, disableOnInteraction: false }"
            :pagination="pagination"
            @swiper="onSwiper"
          >
            <!-- slide 1 -->
            <SwiperSlide v-for="(item, index) in bannerItems" :key="index">
              <a
                :href="formatUrl(item.url)"
                target="_blank"
                rel="noopener noreferrer"
                class="intro-card"
              >
                <div class="pc">
                  <img
                    :src="item.src"
                    :alt="item.alt || '배너 이미지'"
                    class="intro-card__img"
                  />
                </div>
                <div class="m">
                  <img
                    :src="item.mobileSrc"
                    :alt="item.alt || '모바일 배너 이미지'"
                    class="intro-card__img"
                  />
                </div>
              </a>
            </SwiperSlide>

            <template #container-end>
              <div class="intro-controls">
                <div
                  class="intro-bullets"
                  aria-label="슬라이드 위치 표시"
                ></div>
                <button
                  v-if="slideCount > 1"
                  class="intro-play"
                  type="button"
                  :aria-label="isPlaying ? '자동재생 정지' : '자동재생 시작'"
                  :aria-pressed="isPlaying ? 'true' : 'false'"
                  @click="toggleAutoplay"
                >
                  <span v-if="isPlaying" aria-hidden="true">
                    <img src="@/assets/img/icon_stop.svg" alt="" />
                  </span>
                  <span v-else aria-hidden="true">▶</span>
                  <span class="sr-only">{{ isPlaying ? "정지" : "재생" }}</span>
                </button>
              </div>
            </template>
          </Swiper>
        </section>
        <MemberPanel @role="(newRole) => (role = newRole)" />
      </section>
      <div class="home-quick__layout">
        <nav class="home-quick__services" aria-label="주요 서비스">
          <h3 class="sr-only">주요 서비스</h3>
          <ul class="service-list">
            <li class="service-list__item">
              <router-link
                to="/report/submission"
                class="service-list__link"
                aria-label="취약점 제보 서비스 바로가기"
              >
                <span aria-hidden="true"
                  ><img
                    src="@/assets/img/main/img_report.png"
                    alt=""
                    class="light-only"
                /></span>
                <span aria-hidden="true"
                  ><img
                    src="@/assets/img/main/img_report_dark.png"
                    alt=""
                    class="dark-only"
                /></span>
                <p class="service-list__title">취약점 제보</p>
              </router-link>
            </li>
            <li class="service-list__item">
              <router-link
                to="/patch/submission"
                class="service-list__link"
                aria-label="취약점 조치 서비스 바로가기"
              >
                <span aria-hidden="true"
                  ><img
                    src="@/assets/img/main/img_action.png"
                    alt=""
                    class="light-only"
                /></span>
                <span aria-hidden="true"
                  ><img
                    src="@/assets/img/main/img_action_dark.png"
                    alt=""
                    class="dark-only"
                /></span>
                <p class="service-list__title">취약점 조치</p>
              </router-link>
            </li>
            <li class="service-list__item">
              <router-link
                :to="`${
                  role !== null && role === 'REPORT' ? 'report' : 'patch'
                }/hackthechallenge/access`"
                class="service-list__link"
                aria-label="핵더챌린지 서비스 바로가기"
              >
                <span aria-hidden="true"
                  ><img
                    src="@/assets/img/main/img_hackchallenge.png"
                    alt=""
                    class="light-only"
                /></span>
                <span aria-hidden="true"
                  ><img
                    src="@/assets/img/main/img_hackchallenge_dark.png"
                    alt=""
                    class="dark-only"
                /></span>
                <p class="service-list__title">핵더챌린지</p>
              </router-link>
            </li>
            <li class="service-list__item">
              <router-link
                to="/security/scan"
                class="service-list__link"
                aria-label="내 PC 취약점 검사 서비스 바로가기"
              >
                <span aria-hidden="true"
                  ><img
                    src="@/assets/img/main/img_pcscan.png"
                    alt=""
                    class="light-only"
                /></span>
                <span aria-hidden="true"
                  ><img
                    src="@/assets/img/main/img_pcscan_dark.png"
                    alt=""
                    class="dark-only"
                /></span>
                <p class="service-list__title">내PC취약점검사</p>
              </router-link>
            </li>
            <li class="service-list__item">
              <router-link
                to="/member/foreigners"
                class="service-list__link"
                aria-label="For Foreigners 서비스 바로가기"
              >
                <span aria-hidden="true"
                  ><img
                    src="@/assets/img/main/img_foreigners.png"
                    alt=""
                    class="light-only"
                /></span>
                <span aria-hidden="true"
                  ><img
                    src="@/assets/img/main/img_foreigners_dark.png"
                    alt=""
                    class="dark-only"
                /></span>
                <p class="service-list__title">For Foreigners</p>
              </router-link>
            </li>
          </ul>
        </nav>
        <article class="home-quick__bounty">
          <h3 class="bounty__title">
            보안 취약점 신고포상제 <br />
            바로알기
          </h3>
          <router-link
            to="/overview/bugbounty"
            class="btn bounty__link"
            aria-label="보안 취약점 신고포상제 바로알기 페이지 이동"
            >바로알기</router-link
          >
        </article>
      </div>
      <!-- 보안공지 & 공지사항 & TOP10 -->
      <section class="panel-group">
        <h2 class="sr-only">공지</h2>
        <!-- 보안공지 -->
        <article class="panel-group__panel">
          <div class="panel-group__head">
            <h3 class="panel-group__title">보안공지</h3>
            <router-link
              to="/info/vuln/notice"
              class="panel-group__more"
              aria-label="보안공지 더보기"
              >+ 더보기</router-link
            >
          </div>
          <ul class="panel-group__list">
            <li
              class="panel-group__item"
              v-for="(item, index) in vulNoticeItems"
              :key="index"
            >
              <a
                @click="
                  () => {
                    markNoticeAsRead(item);
                    goToVulNDetail(item);
                  }
                "
                class="panel-group__row"
              >
                <p class="panel-group__subject">
                  <span class="panel-group__headline" :title="item.title">{{
                    item.title
                  }}</span>
                  <span
                    v-if="isNewNotice(item)"
                    class="panel-group__badge"
                    aria-label="새 글"
                    >N</span
                  >
                </p>
                <time class="panel-group__date" datetime="2025-07-28">{{
                  convertDateFormatFromId(item.id)
                }}</time>
              </a>
            </li>
          </ul>
        </article>
        <!-- 공지사항 -->
        <article class="panel-group__panel">
          <div class="panel-group__head">
            <h3 class="panel-group__title notice">공지사항</h3>
            <router-link
              to="/info/notice"
              class="panel-group__more"
              aria-label="공지사항 더보기"
              >+ 더보기</router-link
            >
          </div>
          <ul class="panel-group__list notice">
            <li
              class="panel-group__item"
              v-for="(item, index) in noticeItems"
              :key="index"
            >
              <a
                @click="
                  () => {
                    markNoticeAsRead(item);
                    goToNoticeDetail(item);
                  }
                "
                class="panel-group__row"
              >
                <p class="panel-group__subject">
                  <span class="panel-group__headline" :title="item.title">{{
                    item.title
                  }}</span>
                  <span
                    v-if="isNewNotice(item)"
                    class="panel-group__badge"
                    aria-label="새 글"
                    >N</span
                  >
                </p>
                <time class="panel-group__date" datetime="2025-07-28">{{
                  convertDateFormat(item.regDate)
                }}</time>
              </a>
            </li>
          </ul>
        </article>
        <!-- TOP 10 -->
        <article class="panel-group__panel">
          <div class="panel-group__head">
            <h3 class="panel-group__title top">TOP 10</h3>
            <p class="panel-group__asof">
              {{ convertDateFormat(new Date()) }} 기준
            </p>
          </div>
          <div class="panel-group__panel--top">
            <!-- 'CVE 이슈 TOP 10' KISA에서 정리가 안된 내용으로 협의 완료전까지 미표기 -->
            <Tabs
              :tabs="[
                { label: 'CVE TOP 10', tooltip: '' },
                { label: 'CWE TOP 10', tooltip: '올해 기준, 가장 공격 영향' },
              ]"
              v-model="selectedTab"
              role="tablist"
              tabWrapClass="type-none-mb type-point"
            />
            <div
              v-show="selectedTab === 0"
              id="tabpanel-0"
              role="tabpanel"
              :aria-labelledby="'tab-0'"
              aria-label="TOP 10 탭 선택"
            >
              <ul class="top__list">
                <li
                  class="top__item top__link"
                  v-for="(item, index) in cveItems"
                  :key="index"
                >
                  <p
                    class="top__title"
                    :class="{ 'is-active': index % 2 === 0 }"
                  >
                    <span class="top__num">{{ index + 1 }}</span>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      :href="goToCveDetail(item.cveId)"
                    >
                      <span class="ellipsis" :title="item.cveId">
                        {{ item.cveId }}</span
                      >
                    </a>
                  </p>
                  <span class="top__notice">{{ formatCvss(item.cvss) }}</span>
                </li>
              </ul>
            </div>
            <div
              v-show="selectedTab === 1"
              id="tabpanel-1"
              role="tabpanel"
              :aria-labelledby="'tab-1'"
              aria-label="TOP 10 탭 선택"
            >
              <ul class="top__list">
                <li
                  class="top__item top__link"
                  v-for="(item, index) in cweItems"
                  :key="index"
                >
                  <p
                    class="top__title"
                    :class="{ 'is-active': index % 2 === 0 }"
                  >
                    <span class="top__num">{{ index + 1 }}</span>
                    <span class="ellipsis" :title="item.cweName">
                      {{ item.cweName }}</span
                    >
                  </p>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    :href="goToCweDetail(item.cweId)"
                  >
                    <span class="top__notice">{{ item.cweId }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </article>
      </section>
      <!-- 통계 카드들 -->
      <!-- KISA에서 정리가 안된 내용으로 협의 완료전까지 미표기 -->
      <!-- <section class="status-cards">
        <h2 class="sr-only">통계</h2>
        <ul class="status-cards__list" role="list">
          <li class="status-cards__item">
            <div class="status-cards__head">
              <h3 class="status-cards__title">1주차 취약점 건수</h3>
              <span class="status-cards__data" aria-label="2025년 7월"
                >2025.07</span
              >
            </div>
            <p class="status-cards__num"><strong class="num">993</strong> 건</p>
            <div aria-hidden="true" class="status-cards__chart">
              <img src="@/assets/img/main/icon_chart.svg" alt="" />
            </div>
          </li>
          <li class="status-cards__item">
            <div class="status-cards__head">
              <h3 class="status-cards__title">CVSS 평균 건수</h3>
              <span class="status-cards__data" aria-label="2025년 7월"
                >2025.07</span
              >
            </div>
            <p class="status-cards__num">
              <strong class="num">1.22</strong> 건
            </p>
            <div aria-hidden="true" class="status-cards__chart">
              <img src="@/assets/img/main/icon_chart.svg" alt="" />
            </div>
          </li>
          <li class="status-cards__item">
            <div class="status-cards__head">
              <h3 class="status-cards__title">CVE ID 배포</h3>
              <span class="status-cards__data" aria-label="2025년">2025년</span>
            </div>
            <p class="status-cards__num"><strong class="num">921</strong> 개</p>
            <div aria-hidden="true" class="status-cards__chart">
              <img src="@/assets/img/main/icon_chart.svg" alt="" />
            </div>
          </li>
          <li class="status-cards__item">
            <div class="status-cards__head">
              <h3 class="status-cards__title">CVE ID 배포</h3>
              <span class="status-cards__data" aria-label="전체">전체</span>
            </div>
            <p class="status-cards__num">
              <strong class="num">286,304</strong> 개
            </p>
            <div aria-hidden="true" class="status-cards__chart">
              <img src="@/assets/img/main/icon_chart.svg" alt="" />
            </div>
          </li>
        </ul>
      </section> -->
      <!-- 파트너/회사 슬라이더 -->
      <section class="brand">
        <h2 class="sr-only">파트너</h2>
        <button ref="brandPrev" class="brand-nav brand-prev" aria-label="이전">
          <img src="@/assets/img/main/icon_prev.svg" alt="" />
        </button>
        <Swiper
          class="brand-swiper"
          :modules="brandModules"
          :loop="operationLogoItems.length > 6"
          :autoplay="{ delay: 5000, disableOnInteraction: false }"
          :slides-per-view="6"
          :space-between="25"
          :breakpoints="brandBreakpoints"
          @before-init="onBrandBeforeInit"
        >
          <SwiperSlide
            v-for="item in operationLogoItems"
            :key="item.url"
            class="brand-slide"
          >
            <div class="brand-slide__logo" style="height: 60px">
              <img :src="item.src" :alt="item.url" class="light-only" />
              <img :src="item.src" :alt="item.url" class="dark-only" />
            </div>
            <!-- </span> -->
          </SwiperSlide>
        </Swiper>
        <button ref="brandNext" class="brand-nav brand-next" aria-label="다음">
          <img src="@/assets/img/main/icon_next.svg" alt="" />
        </button>
      </section>
    </div>
    <Popup :popupItems="popupItems" @close="onPopupClose" />
  </main>
</template>
<script>
import dt from "@/component/utils/DateTime.js";
import Tabs from "@/component/ui/Tabs.vue";
import MemberPanel from "@/views/member/MemberPanel.vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/vue";
import { computed, inject, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import Popup from "./Popup.vue";
import { deleteExpiredIndexedDBs } from "@/component/utils/TempSave.js";

export default {
  components: {
    Tabs,
    Swiper,
    SwiperSlide,
    MemberPanel,
    Popup,
  },
  setup(props, { emit }) {
    const axios = inject("axios");
    const store = useStore();
    const router = useRouter();

    // data 정의
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    const role = ref(null);
    const selectedTab = ref(0);
    const bannerModules = [Autoplay, Pagination];
    const brandModules = [Autoplay, Navigation];

    const reportDbName = "vulReport_db";
    const reportStoreName = "reportStore";
    const patchDbName = "vulPatch_db";
    const patchStoreName = "patchStore";

    const pagination = {
      el: ".intro-bullets",
      clickable: true,
      bulletClass: "bullet",
      bulletActiveClass: "active",
      renderBullet: (i, cls) =>
        `<button type="button" class="${cls}" aria-label="${
          i + 1
        }번 슬라이드로 이동">
        <span class="sr-only">${i + 1}번</span>
      </button>`,
    };

    const swiperRef = ref(null);
    const isPlaying = ref(true);
    const slideCount = computed(() => 2);

    const brandPrev = ref(null);
    const brandNext = ref(null);

    const brandBreakpoints = {
      1280: { slidesPerView: 6, spaceBetween: 25 },
      1024: { slidesPerView: 5, spaceBetween: 24 },
      768: { slidesPerView: 4, spaceBetween: 20 },
      0: { slidesPerView: 4, spaceBetween: 16 },
    };

    const vulNoticeItems = ref([]);
    const noticeItems = ref([]);
    const bannerItems = ref([]);
    const popupItems = ref([]);
    const operationLogoItems = ref([]);
    const cweItems = ref([]);
    const cveItems = ref([]);
    const settingData = ref([]);
    const urlMap = [
      { url: "/core/pu/dashboard/popup/get", ref: popupItems },
      { url: "/core/pu/dashboard/banner/get", ref: bannerItems },
      { url: "/core/pu/dashboard/notice/get", ref: noticeItems },
      { url: "/core/pu/dashboard/vuln-notice/get", ref: vulNoticeItems },
      {
        url: "/core/pu/dashboard/operation-intro/get",
        ref: operationLogoItems,
      },
      { url: "/core/pu/dashboard/cwe/get", ref: cweItems },
      { url: "/core/pu/dashboard/cve/get", ref: cveItems },
    ];
    const searchInfo = ref({
      searchOption: "KEYWORD",
      content: "",
      collectionType: "",
      tabs: "ko",
    });
    const search = () => {
      router.push({ path: "/keywordResult", query: searchInfo.value });
    };
    //methods 정의
    const onPopupClose = () => {
      emit("popupClose");
    };

    const getList = async () => {
      // showLoading();
      try {
        const promises = urlMap.map((endpoint) => axios.post(endpoint.url, {}));
        const results = await Promise.allSettled(promises);

        results.forEach((result, index) => {
          const { ref: targetRef } = urlMap[index];

          if (
            result.status === "fulfilled" &&
            result.value.data.resType === "RES_OK"
          ) {
            //각 데이터에 담기
            targetRef.value = result.value.data.resList;
          } else {
            targetRef.value = []; // 데이터 초기화
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        // hideLoading();
      }
    };
    const getSettings = async () => {
      const type = "portalUrl";
      try {
        const response = await axios.post("/core/pu/code/settings/get", {
          type,
        });
        if (response.data.resType === "RES_OK") {
          settingData.value = response.data.resList;
        }
      } catch (error) {
        console.error(error);
      }
    };
    const onSwiper = (swiper) => {
      swiperRef.value = swiper;

      requestAnimationFrame(() => {
        swiper.update();
        swiper.autoplay?.start();
      });

      isPlaying.value = !!(swiper.params.autoplay && swiper.autoplay?.running);
      swiper.on("autoplayStart", () => (isPlaying.value = true));
      swiper.on("autoplayStop", () => (isPlaying.value = false));
    };
    const toggleAutoplay = () => {
      const s = swiperRef.value;
      if (!s || !s.autoplay) return;
      s.autoplay.running ? s.autoplay.stop() : s.autoplay.start();
    };
    const onBannerBeforeInit = (swiper) => {
      swiper.params.pagination.el = introBullets.value;
    };
    const onBrandBeforeInit = (swiper) => {
      swiper.params.navigation.prevEl = brandPrev.value;
      swiper.params.navigation.nextEl = brandNext.value;
    };
    const goToVulNDetail = (item) => {
      // 상세 페이지로 이동
      router.push({
        name: "vulnNoticeDetail",
        query: {
          id: item.id,
        },
      });
    };
    const goToNoticeDetail = (item) => {
      // 상세 페이지로 이동
      router.push({
        name: "noticeDetail",
        query: {
          id: item.id,
        },
      });
    };
    const convertDateFormat = (date) => {
      return dt.dateFormat(date);
    };
    const convertDateFormatFromId = (objectId) => {
      return dt.dateFromObjectId(objectId);
    };
    const goToSecurityScan = () => {
      router.push({ path: "/security/scan" });
    };
    const isNewNotice = (item) => {
      // 세션스토리지에서 읽음 처리된 notice id 목록을 가져옴 (없으면 빈 배열)
      const readNotices = JSON.parse(
        localStorage.getItem("readNotices") || "[]"
      );
      // 읽지 않은 글이면 true 반환
      if (readNotices.includes(item.id)) {
        return false;
      }

      // 등록이 7일 이내 데이터 확인
      const timestamp = parseInt(item.id.substring(0, 8), 16) * 1000;
      const createdAt = new Date(timestamp);
      const now = new Date();
      const diffDays = (now - createdAt) / (1000 * 60 * 60 * 24);

      return diffDays <= 7;
    };
    const markNoticeAsRead = (item) => {
      let readNotices = JSON.parse(localStorage.getItem("readNotices") || "[]");
      if (!readNotices.includes(item.id)) {
        readNotices.push(item.id);
        localStorage.setItem("readNotices", JSON.stringify(readNotices));
      }
    };

    const formatUrl = (url) => {
      // 팝업 클릭시 url이동
      if (!url) return "#";
      if (url.startsWith("http://") || url.startsWith("https://")) {
        return url;
      }
      return `http://${url}`;
    };

    const goToCweDetail = (cweId) => {
      const cweNumber = cweId.split("-")[1];
      if (cweNumber) {
        const url = `${settingData.value[0]?.cweUrl}/${cweNumber}`;
        return url;
      }
      return "#";
    };
    const goToCveDetail = (cveId) => {
      const url = `${settingData.value[0]?.cveUrl}/${cveId}`;
      return url;
    };
    const formatCvss = (value) => {
      const text = String(value).trim();
      const match = text.match(/^([\d.]+)\s*\(?\s*([A-Za-z]+)\s*\)?$/);
      const number = match[1];
      const labelRaw = match[2].toLowerCase();
      const label = labelRaw.charAt(0).toUpperCase() + labelRaw.slice(1);

      return `${number} (${label})`;
    };

    const handleDeleteExpiredIndexedDBs = () => {
      const targets = [
        { dbName: reportDbName, storeName: reportStoreName },
        { dbName: patchDbName, storeName: patchStoreName },
      ];
      deleteExpiredIndexedDBs({ targets });
    };
    // life cycle 정의
    onMounted(() => {
      handleDeleteExpiredIndexedDBs();
      getList();
      getSettings();
    });
    // html에서 사용될 데이터 정의
    return {
      search,
      onBrandBeforeInit,
      // onBannerBeforeInit,
      toggleAutoplay,
      onSwiper,
      brandBreakpoints,
      brandPrev,
      brandNext,
      slideCount,
      isPlaying,
      pagination,
      selectedTab,
      vulNoticeItems,
      noticeItems,
      bannerItems,
      popupItems,
      cweItems,
      cveItems,
      operationLogoItems,
      goToVulNDetail,
      goToNoticeDetail,
      goToSecurityScan,
      convertDateFormat,
      convertDateFormatFromId,
      isNewNotice,
      markNoticeAsRead,
      onPopupClose,
      role,
      formatUrl,
      bannerModules,
      brandModules,
      goToCweDetail,
      goToCveDetail,
      formatCvss,
    };
  },
};
</script>
